import { render, staticRenderFns } from "./ProfileStats.vue?vue&type=template&id=25781b90&scoped=true&"
import script from "./ProfileStats.vue?vue&type=script&lang=js&"
export * from "./ProfileStats.vue?vue&type=script&lang=js&"
import style0 from "./ProfileStats.vue?vue&type=style&index=0&id=25781b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25781b90",
  null
  
)

export default component.exports